import { RoleTemplate } from '../_models/role-template.model';
// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud/models/query-models/query-results.model';
// State
import { RoleTemplateState } from '../_reducers/role-template.reducers';
import { each } from 'lodash-es';

export const selectRoleTemplateState = createFeatureSelector<RoleTemplateState>('roleTemplates');

export const selectRoleTemplateById = (roleId: number) =>
  createSelector(
    selectRoleTemplateState,
    (roleTemplateState) => roleTemplateState.entities[roleId],
  );

export const allRoleTemplatesLoaded = createSelector(
  selectRoleTemplateState,
  (roleTemplateState) => roleTemplateState.isAllRoleTemplatesLoaded,
);

export const selectRoleTemplatesPageLoading = createSelector(
  selectRoleTemplateState,
  (roleTemplateState) => roleTemplateState.listLoading,
);

export const selectRolesShowInitWaitingMessage = createSelector(
  selectRoleTemplateState,
  (roleTemplateState) => roleTemplateState.showInitWaitingMessage,
);

export const selectRoleTemplateLatestSuccessfullAction = createSelector(
  selectRoleTemplateState,
  (roleTemplateState) => roleTemplateState.latestSuccessfullAction,
);

export const selectRoleTemplateError = createSelector(
  selectRoleTemplateState,
  (roleTemplateState) => roleTemplateState.error,
);

export const selectQueryResult = createSelector(selectRoleTemplateState, (roleTemplateState) => {
  const items: RoleTemplate[] = [];
  each(roleTemplateState.ids, (ele) => {
    const index: number = +ele;
    items.push(roleTemplateState.entities[index]);
  });
  return new QueryResultsModel(items, roleTemplateState.totalCount);
});
